import React from "react";
import { Helmet } from "react-helmet";

const MetaDataTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default MetaDataTitle;
